define('areas/organizationmanager/models/dto',["require", "exports"], function (require, exports) {
    "use strict";
    var Organization = (function () {
        function Organization() {
        }
        return Organization;
    }());
    exports.Organization = Organization;
    var NetworkMember = (function () {
        function NetworkMember() {
        }
        return NetworkMember;
    }());
    exports.NetworkMember = NetworkMember;
});

